// Images
export const images = {
  bg: '/assets/images/bg.png',
  calendar: '/assets/images/calendar.png',
  deslogo: '/assets/images/deslogo.png',
  forgetpassword: '/assets/images/forgetpassword.png',
  hi: '/assets/images/hi.png',
  icon: '/assets/images/icon.png',
  productImage: '/assets/images/product-image.png',
  profile: '/assets/images/profile.png',
};

// SVG Icons
export const icons = {
  accept: '/assets/svg/accept.svg',
  addButton: '/assets/svg/add_button.svg',
  addDelivery: '/assets/svg/add_delevary.svg',
  backArrow: '/assets/svg/back_arrow.svg',
  backButton: '/assets/svg/backbutton.svg',
  blackBackButton: '/assets/svg/black_back_button.svg',
  check: '/assets/svg/check.svg',
  courier: '/assets/svg/courier.svg',
  delete: '/assets/svg/delete.svg',
  delivery: '/assets/svg/delevary.svg',
  done: '/assets/svg/done.svg',
  download: '/assets/svg/download.svg',
  edit: '/assets/svg/edit.svg',
  emptyOrder: '/assets/svg/empty_order.svg',
  g1089: '/assets/svg/g1089.svg',
  logo: '/assets/svg/logo.svg',
  logo2: '/assets/svg/logo2.svg',
  manageAccounts: '/assets/svg/manage_accounts.svg',
  newspaper: '/assets/svg/newspaper.svg',
  order: '/assets/svg/order.svg',
  package: '/assets/svg/package.svg',
  reject: '/assets/svg/reject.svg',
  rejectButton: '/assets/svg/rejectbt.svg',
  sales: '/assets/svg/sales.svg',
  update: '/assets/svg/update.svg',
  userAvatar: '/assets/svg/userAvatar.svg',
  users: '/assets/svg/users.svg',
  view: '/assets/svg/view.svg',
};

// Logo variations
export const logos = {
  primary: images.deslogo,
  svg: icons.logo,
  svg2: icons.logo2,
};

// Background images
export const backgrounds = {
  main: images.bg,
  login: images.bg,
};

// User related images
export const userImages = {
  avatar: icons.userAvatar,
  profile: images.profile,
  hi: images.hi,
};

// Product images
export const productImages = {
  default: images.productImage,
};

// Calendar
export const calendar = {
  icon: images.calendar,
};

export default {
  images,
  icons,
  logos,
  backgrounds,
  userImages,
  productImages,
  calendar,
};
